import Vue from 'vue';
import Router from 'vue-router';
import Content from './components/Content.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/map/:projectid',
      name: 'map_base',
      component: Content,
    },
    {
      path: '/map/:projectid/:level',
      name: 'map',
      component: Content,
    },
  ],
});
